<!-- 
    Image Element:
        Props:
        imageSrc: url des Images
        scaling: wie soll das Image skaliert siehe css object-fit
 -->

<template>
    <div class="image-item">
        <img
            :src="imageSrc"
            alt="image"
            class="image"
            :style="{ 'object-fit': scaling, 'background-color': backgroundColor }"
            @load="$emit('imgLoaded', true)"
        />
    </div>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        backgroundColor?: string;
        imageSrc?: string;
        scaling?: "cover" | "fill" | "contain" | "none" | "scale-down";
    }>(),
    {
        backgroundColor: "transparent",
        scaling: "cover",
    }
);

defineEmits({
    imgLoaded: null,
});
</script>

<style lang="scss" scoped>
.image {
    width: 100%;
    object-position: center;
}

.image-item {
    width: 100%;
}
</style>
